import { SideNav } from '@shinetools/lumen-react'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoicingSettingsHost } from '../../../../contexts/invoicingSettingsHostContext'
import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { INVOICING_SETTINGS_SIDE_NAV_WIDTH } from '../../constants/invoicingSettingsSideNavWidth'
import { useInvoicingSettingsNavItems } from '../../hooks/useInvoicingSettingsNavItems'
import { InvoicingSettingsModalNavigationItem } from './elements/InvoicingSettingsModalNavigationItem'

export const InvoicingSettingsModalNavigation = (): ReactElement => {
  const { t } = useTranslation()
  const { activeSection, requestNavigation } = useInvoicingSettingsHost()
  const navItems = useInvoicingSettingsNavItems()

  const handleNavItemSelect = useCallback(
    (section: InvoicingSettingsSection) => {
      requestNavigation({ section, type: 'section' })
    },
    [requestNavigation],
  )

  return (
    <SideNav aria-label={t('invoicing_settings.title')} width={INVOICING_SETTINGS_SIDE_NAV_WIDTH}>
      <SideNav.Header>
        <SideNav.Label label={t('invoicing_settings.title')} />
      </SideNav.Header>
      <SideNav.Body>
        <SideNav.Group>
          {navItems.map(({ label, section }) => (
            <InvoicingSettingsModalNavigationItem
              isSelected={section === activeSection}
              key={section}
              label={label}
              onSelect={handleNavItemSelect}
              section={section}
            />
          ))}
        </SideNav.Group>
      </SideNav.Body>
    </SideNav>
  )
}
